import { createAction, createReducer } from '@reduxjs/toolkit'

type State = {
  hasNewMedicationFollowUpNotification: boolean
}

const initialState = { hasNewMedicationFollowUpNotification: false }

export function createInitialState(): State {
  return initialState
}

const SET_HAS_NEW_MEDICATION_FOLLOW_UP_NOTIFICATION = 'has-new-medication-follow-up-notification/set' as const
const CLEAR_HAS_NEW_MEDICATION_FOLLOW_UP_NOTIFICATION = 'has-new-medication-follow-up-notification/clear' as const

export const setHasNewMedicationFollowUpNotification = createAction<boolean>(
  SET_HAS_NEW_MEDICATION_FOLLOW_UP_NOTIFICATION,
)
export const clearHasNewMedicationFollowUpNotification = createAction(CLEAR_HAS_NEW_MEDICATION_FOLLOW_UP_NOTIFICATION)

export const reducer = createReducer(createInitialState(), builder => {
  builder
    .addCase(setHasNewMedicationFollowUpNotification, (state, action) => {
      state.hasNewMedicationFollowUpNotification = action.payload
    })
    .addCase(clearHasNewMedicationFollowUpNotification, state => {
      state.hasNewMedicationFollowUpNotification = initialState.hasNewMedicationFollowUpNotification
    })
    .addDefaultCase(() => {
      return
    })
})
